// extracted by mini-css-extract-plugin
module.exports = {"widgetTypeImage":"WidgetTypeImage_widgetTypeImage__3q5yL"};